<template>
    <v-container fluid class="perfil-root">
        <div class="perfil-shell">
            <v-row>
                <v-col cols="12">
                    <div class="perfil-header">
                        <div>
                            <h1 class="perfil-title">SISTEMA DE GESTIÓN DE FUNCIONARIOS</h1>
                        </div>
                        <div class="perfil-header-status">
                            <div class="status-pill">
                                <span class="status-pill__label">Activo</span>
                                <span class="status-pill__value">{{ perfil.activo ? 'Sí' : 'No' }}</span>
                            </div>
                            <div class="status-pill status-pill--soft">
                                <span class="status-pill__label">Verificado</span>
                                <span class="status-pill__value">{{ perfil.verificado === true ? 'Sí' : 'No' }}</span>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>

            <v-row class="mt-1">
                <v-col cols="12">
                    <v-card class="perfil-card perfil-card--side" outlined>
                        <v-card-text class="basic-strip">
                            <div class="basic-strip__identity">
                                <v-avatar size="88" class="perfil-avatar">
                                    <v-img
                                        :src="fotoPreview || 'https://cdn-icons-png.flaticon.com/512/149/149071.png'"
                                        cover
                                    ></v-img>
                                </v-avatar>

                                <div class="basic-strip__copy">
                                    <div class="perfil-nombre">{{ nombreCompleto }}</div>
                                    <div class="perfil-subtitulo perfil-subtitulo--cargo">{{ getGradoN(perfil.oid_grado) }}</div>
                                    <div class="perfil-subtitulo perfil-subtitulo--correo">{{ perfil.correo || '-' }}</div>
                                </div>
                            </div>

                            <div class="basic-strip__content">
                                <v-row>
                                    <v-col cols="12" lg="3" md="6" xs="12">
                                        <div class="compact-pill">
                                            <span class="compact-pill__label">
                                                <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-card-account-details-outline</v-icon>
                                                Nro Escalafon
                                            </span>
                                            <span class="compact-pill__value">{{ perfil.cl1 || '-' }}</span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" lg="3" md="6" xs="12">
                                        <div class="compact-pill">
                                            <span class="compact-pill__label">
                                                <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-card-account-details-outline</v-icon>
                                                Documento
                                            </span>
                                            <span class="compact-pill__value">{{ perfil.documento || '-' }}</span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" lg="3" md="6" xs="12">
                                        <div class="compact-pill">
                                            <span class="compact-pill__label">
                                                <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-phone-outline</v-icon>
                                                Teléfono
                                            </span>
                                            <span class="compact-pill__value">{{ perfil.telefono || '-' }}</span>
                                        </div>  
                                    </v-col>
                                    <v-col cols="12" lg="3" md="6" xs="12">
                                        <div class="compact-pill">
                                            <span class="compact-pill__label">
                                                <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-map-marker-outline</v-icon>
                                                Dirección
                                            </span>
                                            <span class="compact-pill__value">{{ perfil.direccion || '-' }}</span>
                                        </div>  
                                    </v-col>
                                </v-row>

                                <!-- <div class="compact-summary-grid compact-summary-grid--wide">
                                    <div class="compact-pill">
                                        <span class="compact-pill__label">
                                            <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-card-account-details-outline</v-icon>
                                            Nro Escalafon
                                        </span>
                                        <span class="compact-pill__value">{{ perfil.cl1 || '-' }}</span>
                                    </div>
                                    <div class="compact-pill">
                                        <span class="compact-pill__label">
                                            <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-card-account-details-outline</v-icon>
                                            Documento
                                        </span>
                                        <span class="compact-pill__value">{{ perfil.documento || '-' }}</span>
                                    </div>
                                    <div class="compact-pill">
                                        <span class="compact-pill__label">
                                            <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-phone-outline</v-icon>
                                            Teléfono
                                        </span>
                                        <span class="compact-pill__value">{{ perfil.telefono || '-' }}</span>
                                    </div>                                    
                                    <div class="compact-pill">
                                        <span class="compact-pill__label">
                                            <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-map-marker-outline</v-icon>
                                            Dirección
                                        </span>
                                        <span class="compact-pill__value">{{ perfil.direccion || '-' }}</span>
                                    </div>                                  
                                </div> -->
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card class="perfil-card" outlined>
                        <v-card-text>
                            <div class="section-title mb-4">
                                <v-icon small color="#F7C325" class="mr-2">mdi-view-grid</v-icon>
                                MENÚ DE OPCIONES
                            </div>

                            <div class="menu-grid menu-grid--four-up">
                                <div class="menu-grid__item" v-for="item in menuOpciones" :key="item.titulo">
                                    <v-card class="menu-card" @click="ejecutarAccion(item)">
                                        <div class="menu-icon-wrapper">
                                            <v-icon size="30" color="#F7C325">{{ item.icono }}</v-icon>
                                        </div>
                                        <div class="menu-title">{{ item.titulo }}</div>
                                        <div class="menu-subtitle">{{ item.subtitulo }}</div>
                                    </v-card>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card class="perfil-card mt-2" outlined>
                        <v-card-text>
                            <div class="section-title mb-4">
                                <v-icon small color="#F7C325" class="mr-2">mdi-card-account-details</v-icon>
                                RESUMEN DEL PERFIL
                            </div>

                            <v-row dense>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <div class="info-box info-box--compact">
                                        <div class="info-label">Nombres</div>
                                        <div class="info-value">{{ perfil.nombres || '-' }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <div class="info-box info-box--compact">
                                        <div class="info-label">Apellido paterno</div>
                                        <div class="info-value">{{ perfil.primero_apellido || '-' }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <div class="info-box info-box--compact">
                                        <div class="info-label">Apellido materno</div>
                                        <div class="info-value">{{ perfil.segundo_apellido || '-' }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <div class="info-box info-box--compact">
                                        <div class="info-label">Correo</div>
                                        <div class="info-value">{{ perfil.correo || '-' }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <div class="info-box info-box--compact">
                                        <div class="info-label">Documento</div>
                                        <div class="info-value">{{ perfil.documento || '-' }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <div class="info-box info-box--compact">
                                        <div class="info-label">Teléfono</div>
                                        <div class="info-value">{{ perfil.telefono || '-' }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <div class="info-box info-box--compact">
                                        <div class="info-label">Fecha nacimiento</div>
                                        <div class="info-value">{{ formatoFecha(perfil.fecha_nacimiento) }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <div class="info-box info-box--compact">
                                        <div class="info-label">Fecha de registro</div>
                                        <div class="info-value">{{ formatoFecha(perfil.created_at) }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <div class="info-box info-box--compact">
                                        <div class="info-label">Activo</div>
                                        <div class="info-value">{{ perfil.activo ? 'Sí' : 'No' }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3">
                                    <div class="info-box info-box--compact">
                                        <div class="info-label">Verificado</div>
                                        <div class="info-value">{{ perfil.verificado === true ? 'Sí' : 'No' }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="8" lg="6">
                                    <div class="info-box info-box--compact mb-0">
                                        <div class="info-label">Dirección</div>
                                        <div class="info-value">{{ perfil.direccion || '-' }}</div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>

        <v-dialog v-model="dialog_datos" max-width="80%" scrollable>
            <v-card class="perfil-card dialog-card">
                <v-card-title class="dialog-header d-flex justify-space-between align-center">
                    <span class="perfil-nombre dialog-title">
                        {{ (dato.nombres || '') + ' ' + (dato.apellidos || '') }}
                    </span>
                    <v-btn icon class="header-close" @click="dialog_datos = false">
                        <v-icon color="#384018">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-4">
                    <div class="section-title section-title--dialog mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-account</v-icon>
                        DATOS PERSONALES
                    </div>

                    <v-row>
                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nombres</div>
                                <div class="info-value">{{ dato.nombres || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Apellido paterno</div>
                                <div class="info-value">{{ dato.primero_apellido || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Apellido materno</div>
                                <div class="info-value">{{ dato.segundo_apellido || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Tercer apellido</div>
                                <div class="info-value">{{ dato.tercer_apellido || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Correo</div>
                                <div class="info-value">{{ dato.correo || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Tipo Documento</div>
                                <div class="info-value">{{ (catMap.TipoDocumento || {})[dato.oid_tipo_documento] || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Documento</div>
                                <div class="info-value">{{ dato.documento || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Expedido</div>
                                <div class="info-value">{{ dato.expedido || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Género</div>
                                <div class="info-value">{{ (catMap.Genero || {})[dato.oid_genero] || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Fecha Nacimiento</div>
                                <div class="info-value">
                                    {{ formatoFecha(perfil.fecha_nacimiento) }}
                                </div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Edad</div>
                                <div class="info-value">
                                    {{ calcularEdad(perfil.fecha_nacimiento) || '—' }}
                                </div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Estado Civil</div>
                                <div class="info-value">{{ (catMap.EstadoCivil || {})[dato.oid_estado_civil] || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Teléfono</div>
                                <div class="info-value">{{ dato.telefono || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nacionalidad origen</div>
                                <div class="info-value">{{ (catMap.Nacionalidad || {})[dato.oid_nacionalidad_origen] || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nacionalidad actual</div>
                                <div class="info-value">{{ (catMap.Nacionalidad || {})[dato.oid_nacionalidad_actual] || '—' }}</div>
                            </div>
                        </v-col>
                    </v-row>

                    <div class="section-title section-title--dialog mt-6 mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-map-marker-radius</v-icon>
                        LUGAR DE NACIMIENTO
                    </div>

                    <v-row>
                        <v-col cols="12" md="4">
                            <div class="info-box">
                                <div class="info-label">País nacimiento</div>
                                <div class="info-value">{{ getPaisN(dato.oid_pais_nacimiento) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box">
                                <div class="info-label">Departamento nacimiento</div>
                                <div class="info-value">{{ getDeptoN(dato.oid_depto_nacimiento) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box">
                                <div class="info-label">Ciudad nacimiento</div>
                                <div class="info-value">{{ getCiudadN(dato.oid_ciudad_nacimiento) }}</div>
                            </div>
                        </v-col>
                    </v-row>

                    <div class="section-title section-title--dialog mt-6 mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-home-city</v-icon>
                        DOMICILIO ACTUAL
                    </div>

                    <v-row>
                        <v-col cols="12" md="4">
                            <div class="info-box">
                                <div class="info-label">Dirección</div>
                                <div class="info-value">{{ dato.direccion || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="2">
                            <div class="info-box">
                                <div class="info-label">Calle</div>
                                <div class="info-value">{{ dato.calle || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Zona</div>
                                <div class="info-value">{{ dato.zona || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nro domicilio</div>
                                <div class="info-value">{{ dato.nro_domicilio || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">País</div>
                                <div class="info-value">{{ getPaisN(dato.oid_pais) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">Departamento</div>
                                <div class="info-value">{{ getDeptoN(dato.oid_depto) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">Ciudad</div>
                                <div class="info-value">{{ getCiudadN(dato.oid_ciudad) }}</div>
                            </div>
                        </v-col>
                    </v-row>

                    <div class="section-title section-title--dialog mt-6 mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-shield-account</v-icon>
                        INFORMACIÓN ADICIONAL
                    </div>

                    <v-row>
                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Código de salud</div>
                                <div class="info-value">{{ dato.cod_salud || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Registro CUA</div>
                                <div class="info-value">{{ dato.registro_cua || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nro. cuenta</div>
                                <div class="info-value">{{ dato.nro_cuenta || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Grado incapacidad</div>
                                <div class="info-value">{{ dato.grado_incapacidad || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Bono egresado</div>
                                <div class="info-value">{{ dato.bono_egresado || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Código cargo</div>
                                <div class="info-value">{{ dato.cod_cargo || '—' }}</div>
                            </div>
                        </v-col>
                    </v-row>

                    <div class="section-title section-title--dialog mt-6 mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-phone-alert</v-icon>
                        CONTACTO DE EMERGENCIA
                    </div>

                    <v-row>
                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">Nombre contacto</div>
                                <div class="info-value">{{ dato.n_contacto || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">Nro contacto</div>
                                <div class="info-value">{{ dato.nro_contacto || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">Fecha registro</div>
                                <div class="info-value">{{ formatoFecha(dato.created_at) }}</div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-center pb-4 pt-0">
                    <v-btn class="dialog-action" @click="dialog_datos = false">
                        <v-icon left>mdi-close</v-icon>
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_mapa" max-width="80%" scrollable>
            <v-card class="perfil-card dialog-card">
                <v-card-title class="dialog-header d-flex justify-space-between align-center">
                    <span class="perfil-nombre dialog-title">
                        <v-icon left color="#f7c325">mdi-home</v-icon>
                        DOMICILIOS
                    </span>
                    <v-btn icon class="header-close" @click="dialog_mapa = false">
                        <v-icon color="#384018">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-4">
                    <div class="section-title section-title--dialog mt-2 mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-home</v-icon>
                        UBICACIÓN ACTUAL
                    </div>

                    <v-row>
                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">País</div>
                                <div class="info-value">{{ getPaisN(dato.oid_pais) }}</div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Departamento</div>
                                <div class="info-value">{{ getDeptoN(dato.oid_depto) }}</div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Ciudad</div>
                                <div class="info-value">{{ getCiudadN(dato.oid_ciudad) }}</div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Dirección</div>
                                <div class="info-value">{{ dato.direccion || '—' }}</div>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <div class="d-flex align-center flex-wrap mb-2">
                                <div class="d-flex align-center mr-6 mb-2">
                                    <span class="legend-dot legend-dot-red mr-2"></span>
                                    <span class="legend-label">Ubicación actual</span>
                                </div>
                                <div class="d-flex align-center mb-2">
                                    <span class="legend-dot legend-dot-blue mr-2"></span>
                                    <span class="legend-label">Histórico de ubicaciones</span>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <div id="mapa" class="mapa-surface"></div>
                        </v-col>
                        <v-col cols="12">
                            <div class="section-title section-title--dialog mt-4 mb-3" style="justify-content: center;">
                                <v-icon left color="#f7c325">mdi-history</v-icon>
                                HISTÓRICO DE UBICACIONES
                            </div>

                            <v-simple-table class="historial-table">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Dirección</th>
                                            <th>Ciudad</th>
                                            <th>Departamento</th>
                                            <th>País</th>
                                            <th>Latitud</th>
                                            <th>Longitud</th>
                                            <th>Fecha</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span class="legend-dot legend-dot-red"></span>
                                            </td>
                                            <td>{{ dato.direccion || '—' }}</td>
                                            <td>{{ getCiudadN(dato.oid_ciudad) || '—' }}</td>
                                            <td>{{ getDeptoN(dato.oid_depto) || '—' }}</td>
                                            <td>{{ getPaisN(dato.oid_pais) || '—' }}</td>
                                            <td>{{ formatCoord(dato.lat) }}</td>
                                            <td>{{ formatCoord(dato.lng) }}</td>
                                            <td>Actual</td>
                                        </tr>

                                        <tr v-for="(item, index) in ubicacionesHistoricas" :key="item.oid || index">
                                            <td>
                                                <span class="legend-dot legend-dot-blue"></span>
                                            </td>
                                            <td>{{ item.direccion || '—' }}</td>
                                            <td>{{ getCiudadN(item.oid_ciudad) || '—' }}</td>
                                            <td>{{ getDeptoN(item.oid_depto) || '—' }}</td>
                                            <td>{{ getPaisN(item.oid_pais) || '—' }}</td>
                                            <td>{{ formatCoord(item.lat) }}</td>
                                            <td>{{ formatCoord(item.lng) }}</td>
                                            <td>{{ formatoFechaHora(item.created_at) }}</td>
                                        </tr>

                                        <tr v-if="!ubicacionesHistoricas || ubicacionesHistoricas.length === 0">
                                            <td colspan="8" class="text-center historial-empty">
                                                No hay ubicaciones históricas registradas.
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-center pb-4 pt-0">
                    <v-btn class="dialog-action" @click="dialog_mapa = false">
                        <v-icon left>mdi-close</v-icon>
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_track" max-width="90%" scrollable>
            <v-card class="perfil-card dialog-card">
                <v-card-title class="dialog-header d-flex justify-space-between align-center">
                    <span class="perfil-nombre dialog-title">
                        <v-icon left color="#f7c325">mdi-timeline-clock</v-icon>
                        HOJA DE VIDA
                    </span>

                    <v-btn icon class="header-close" @click="dialog_track = false">
                        <v-icon color="#384018">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pa-4">
                    <div class="section-title section-title--dialog mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-account-check</v-icon>
                        INFORMACIÓN ACTUAL
                    </div>

                    <v-row>
                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Estado actual</div>
                                <div class="info-value">{{ getEstadoN(dato.oid_estado) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Grado</div>
                                <div class="info-value">{{ getGradoN(dato.oid_grado) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Cargo</div>
                                <div class="info-value">{{ getCargoN(dato.oid_cargo) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Unidad</div>
                                <div class="info-value">{{ getUnidadN(dato.oid_unidad) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Destino</div>
                                <div class="info-value">{{ getDestinoN(dato.oid_destino) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nro Escalafon</div>
                                <div class="info-value">{{ dato.cl1 || '—' }}</div>
                            </div>
                        </v-col>

                        <!-- <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">CL2</div>
                                <div class="info-value">{{ dato.cl2 || '—' }}</div>
                            </div>
                        </v-col> 
                        -->
                        
                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Fecha ingreso</div>
                                <div class="info-value">{{ formatoFecha(dato.fecha_ingreso) }}</div>
                            </div>
                        </v-col>

                        <!-- <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Fecha retiro</div>
                                <div class="info-value">{{ formatoFecha(dato.fecha_retiro) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Fecha reintegro</div>
                                <div class="info-value">{{ formatoFecha(dato.fecha_reintegro) }}</div>
                            </div>
                        </v-col> -->
                    </v-row>
                    
                    <v-tabs v-model="tabTrack" background-color="transparent" color="#5e672c" grow>
                        <v-tab>
                            <v-icon left small>mdi-briefcase-clock</v-icon>
                            Histórico Laboral
                        </v-tab>

                        <v-tab>
                            <v-icon left small>mdi-account-clock</v-icon>
                            Histórico de Estados
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tabTrack">

                        <!-- 🟢 TAB 1: HISTORIAL LABORAL -->
                        <v-tab-item>
                            <div class="mt-4">
                                <v-simple-table class="historial-table">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Grado</th>
                                                <th>Cargo</th>
                                                <th>Unidad</th>
                                                <th>Destino</th>
                                                <th>Fecha inicio</th>
                                                <th>Fecha fin</th>
                                                <th>Acción</th>
                                                <th>Observación</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="(item, index) in historialLaboral" :key="item.oid || index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ getGradoN(item.oid_grado) }}</td>
                                                <td>{{ getCargoN(item.oid_cargo) }}</td>
                                                <td>{{ getUnidadN(item.oid_unidad) }}</td>
                                                <td>{{ getDestinoN(item.oid_destino) }}</td>
                                                <td>{{ formatoFecha(item.fecha_inicio) }}</td>
                                                <td>{{ formatoFecha(item.fecha_fin) }}</td>
                                                <td>{{ getAccionHistorial(item.accion) }}</td>
                                                <td>{{ item.observacion || '—' }}</td>
                                            </tr>

                                            <tr v-if="!historialLaboral || historialLaboral.length === 0">
                                                <td colspan="9" class="text-center historial-empty">
                                                    No hay histórico laboral registrado.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </div>
                        </v-tab-item>

                        <!-- 🔵 TAB 2: HISTORIAL ESTADOS -->
                        <v-tab-item>
                            <div class="mt-4">
                                <v-simple-table class="historial-table">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Estado</th>
                                                <th>Fecha inicio</th>
                                                <th>Fecha fin</th>
                                                <th>Observación</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="(item, index) in historialEstados" :key="item.oid || index">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ getEstadoN(item.oid_estado) }}</td>
                                                <td>{{ formatoFecha(item.fecha_inicio) }}</td>
                                                <td>{{ formatoFecha(item.fecha_fin) }}</td>
                                                <td>{{ item.observacion || '—' }}</td>
                                            </tr>

                                            <tr v-if="!historialEstados || historialEstados.length === 0">
                                                <td colspan="6" class="text-center historial-empty">
                                                    No hay histórico de estados registrado.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </div>
                        </v-tab-item>

                    </v-tabs-items>
                </v-card-text>

                <v-card-actions class="justify-center pb-4 pt-0">
                    <v-btn class="dialog-action" @click="dialog_track = false">
                        <v-icon left>mdi-close</v-icon>
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="dialog_familiar" max-width="90%" scrollable>
            <v-card class="perfil-card dialog-card">
                <v-card-title class="dialog-header d-flex justify-space-between align-center">
                    <span class="perfil-nombre dialog-title">
                        <v-icon left color="#f7c325">mdi-timeline-clock</v-icon>
                        ENTORNO FAMILIAR
                    </span>

                    <v-btn icon class="header-close" @click="dialog_familiar = false">
                        <v-icon color="#384018">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pa-4">
                    <div class="section-title section-title--dialog mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-account-check</v-icon>
                        INFORMACIÓN ACTUAL
                    </div>
                    <info-familiar
                        :persona-id="personaId || personaOid"
                        :user-oid="userOid"
                    />
                </v-card-text>

                <v-card-actions class="justify-center pb-4 pt-0">
                    <v-btn class="dialog-action" @click="dialog_familiar = false">
                        <v-icon left>mdi-close</v-icon>
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <carnet v-model="dialog_carnet" :perfil="perfil" />

        <v-dialog v-model="dialog_desarrollo" max-width="460" persistent>
            <v-card class="perfil-card text-center pa-6">
                <v-icon color="#f7c325" size="72" class="mb-4">
                    mdi-tools
                </v-icon>

                <div class="perfil-nombre mb-3" style="font-size: 22px;">
                    Módulo en desarrollo
                </div>

                <div class="grey--text text--darken-1 mb-5">
                    El módulo <b>{{ moduloDesarrollo }}</b> se encuentra actualmente en desarrollo.
                    <br>
                    Pronto estará disponible.
                </div>

                <v-btn class="dialog-action" @click="dialog_desarrollo = false">
                    <v-icon left>mdi-check</v-icon>
                    Entendido
                </v-btn>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="5000" top>
            {{ snackbarMensaje }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
            </template>
        </v-snackbar>
        
    </v-container>
</template>
  
<script>
import axios from 'axios';
import Carnet from '@/components/Perfil/Carnet.vue';
import InfoFamiliar from '@/components/Perfil/InfoFamiliar.vue';
import { setEstados, getEstadoN } from '@/utils/validators';
import {
  loadAll, getOptionsByCodigo,
  setDatos, getPaises, getDeptos, getCiudades,
  getPaisN, getDeptoN, getCiudadN,
  getNameById
} from '@/utils/catalogo';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});
const redIcon = new L.Icon({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIcon2x,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
    className: 'marker-red'
});

const blueIcon = new L.Icon({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIcon2x,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
    className: 'marker-blue'
});
  
export default {
    name: 'Perfil',
    components: {
        Carnet,
        InfoFamiliar,
    },
    props: {
        componente: Array,
        personaId: { type: Number, required: false, default: null },
        soloLectura: { type: Boolean, default: false },
    },
    data() {
        return {
            datos: [], Ldomicilios: [],Lestado: [],
            LPais: [], LDepto: [], LCiudad: [], Lgrado: [], Lcargo: [], Lunidad: [], Ldestino: [],
            dato: {
                oid: 0,
                correo: '',
                nombres: '',
                primero_apellido: "",
                segundo_apellido: "",
                oid_tipo_documento: null,
                documento: '',
                oid_genero: null,
                fecha_nacimiento: null,
                oid_pais_nacimiento: null,
                oid_nacionalidad_origen: null,
                oid_nacionalidad_actual: null,
                oid_estado_civil: null,
                direccion: '',
                oid_pais: null,
                oid_depto: null,
                oid_ciudad: null,
                telefono: '',
                oid_estado: null,
                cl1: '',
                cl2: '',
                fecha_ingreso: null,
                fecha_retiro: null,
                fecha_reintegro: null,
                oid_grado: null,
                oid_cargo: null,
                oid_unidad: null,
                oid_destino: null,
            },
            isNew: true,
            Ops: [
                { oid: 1, nombre: 'Si' },
                { oid: 0, nombre: 'No' },
            ],
            dialog: false, // Controla la visibilidad del diálogo
            formTitle: '', // Título del diálogo
            dialogdetail: false, dialog_mapa: false, dialog_track: false, dialog_datos: false, dialog_carnet: false,
            dialog_familiar: false,
            showConfirmDialog: false,
            confirmItemId: null,
            search: '', // Valor del campo de búsqueda
            dialog_guardando: false,
            snackbar: false,
            snackbarMensaje: '',
            snackbarColor: 'error',
            rules: {
                required: v => v !== null && v !== undefined && v !== '' || 'Requerido',
                maxValue: max => v =>
                    (!v || Number(v) <= max) || `El valor no puede ser mayor a ${max}`,
                select: v => (v !== null && v !== undefined && v !== '') || 'Selecciona una opción',
            },
            formValid: false,
            fotoPreview: "",
            perfil: {
                oid: 0,
                correo: "",
                activo: false,
                nombres: "",
                primero_apellido: "",
                segundo_apellido: "",
                documento: "",
                telefono: "",
                fecha_nacimiento: null,
                direccion: "",
                verificado: null,
                created_at: null
            },
            menuOpciones: [
                {
                    titulo: "Datos personales",
                    subtitulo: "Ver y actualizar información",
                    icono: "mdi-account-box",
                    accion: "datos"
                },
                {
                    titulo: "Domicilios",
                    subtitulo: "Gestionar direcciones",
                    icono: "mdi-home",
                    accion: "domicilios"
                },
                {
                    titulo: "Hoja de Vida",
                    subtitulo: "Historial de carrera",
                    icono: "mdi-key",
                    accion: "track"
                },
                {
                    titulo: "Carnet Digital",
                    subtitulo: "Carnet digital del funcionario",
                    icono: "mdi-card-account-details",
                    accion: "carnet"
                },
                {
                    titulo: "Información Familiar",
                    subtitulo: "Búsqueda de contactos",
                    icono: "mdi-magnify",
                    accion: "contactos"
                },
                {
                    titulo: "Documentación",
                    subtitulo: "Información general",
                    icono: "mdi-school",
                    accion: "estudios"
                },
                {
                    titulo: "Plan de Carrera",
                    subtitulo: "Solicitar información",
                    icono: "mdi-account-details",
                    accion: "configuracion"
                },
                {
                    titulo: "Atención al Funcionario",
                    subtitulo: "Solicitar información",
                    icono: "mdi-chat-processing-outline",
                    accion: "configuracion"
                }
            ],
            Catalogo: {
                EstadoCivil: [],
                TipoDocumento: [],
                Nacionalidad: [],
                Genero: [],
            },
            map: null,
            marker: null,
            markersHistoricos: [],
            ubicacionesHistoricas: [],
            multiplesCiudades: false,
            tabTrack: 0,
            historialLaboral: [],
            historialEstados: [],
            dialog_desarrollo: false, moduloDesarrollo: ''
        };
    },
    computed: {
        headers() {
            const baseHeaders = [
                { text: 'Acciones', value: 'actions', sortable: false },
                { text: 'Nombres', value: 'names' },
                { text: 'Apellidos', value: 'surname' },
                { text: 'Email', value: 'email' },
                { text: 'Rol', value: 'rol' },
                { text: 'Área', value: 'area' },
                { text: 'Activo', value: 'activo' },
            ];

            return baseHeaders;
        },
        userName() {
            const user = localStorage.getItem('userName'); 
            return user;
        },
        rolOid() {
            const oid_rol = localStorage.getItem('rolu');
            return Number(oid_rol);
        },    
        userOid() {
            const oid_user = localStorage.getItem('oidu');
            return Number(oid_user);
        },  
        personaOid() {
            const oid_persona = localStorage.getItem('oidpersonau');
            return Number(oid_persona);
        },
        nombreCompleto() {
            return [
                this.perfil.nombres,
                this.perfil.primero_apellido,
                this.perfil.segundo_apellido
            ]
            .filter(Boolean)
            .join(" ");
        },
        catMap() {
            const toMap = arr => (arr || []).reduce((m, it) => { m[it.oid] = it.nombre; return m; }, {});
            return {
                TipoDocumento: toMap(this.Catalogo.TipoDocumento),
                Nacionalidad:  toMap(this.Catalogo.Nacionalidad),
                Genero:        toMap(this.Catalogo.Genero),
                EstadoCivil:   toMap(this.Catalogo.EstadoCivil),
            };
        }
    },
    watch: {
        dialog_mapa(val) {
            if (val) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.initMap();
                    }, 200);
                });
            } else {
                if (this.map) {
                    this.map.remove();
                    this.map = null;
                }
                this.marker = null;
                this.markersHistoricos = [];
            }
        },
        personaId: {
            handler(newVal) {
                this.dato.oid = newVal;
                this.cargarPerfil();
            },
            immediate: true,
        }
    },
    async mounted() {
        await this.cargarCatalogos();
        await this.cargarCatalogosLaborales();
        
        this.Lestado = await setEstados();

        await setDatos();
        this.LPais   = getPaises();
        this.LDepto  = getDeptos();
        this.LCiudad = getCiudades();
    },
    methods: {
        initMap() {
            const container = document.getElementById('mapa');
            if (!container) return;

            if (this.map) {
                this.map.remove();
                this.map = null;
                this.marker = null;
                this.markersHistoricos = [];
            }

            const paisConfig = this.getCenterByPais(this.dato.oid_pais);

            this.map = L.map(container, {
                preferCanvas: true
            }).setView(paisConfig.center, paisConfig.zoom);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap'
            }).addTo(this.map);

            const bounds = [];

            // actual
            if (this.dato.lat != null && this.dato.lng != null) {
                const lat = Number(this.dato.lat);
                const lng = Number(this.dato.lng);

                if (
                    isFinite(lat) && isFinite(lng) &&
                    lat >= -90 && lat <= 90 &&
                    lng >= -180 && lng <= 180
                ) {
                    this.marker = L.circleMarker([lat, lng], {
                        radius: 10,
                        color: '#ffffff',
                        weight: 2,
                        fillColor: '#d32f2f',
                        fillOpacity: 1
                    })
                    .addTo(this.map)
                    .bindPopup(`
                        <b>Ubicación actual</b><br>
                        ${this.dato.direccion || 'Sin dirección'}
                    `);

                    bounds.push([lat, lng]);
                }
            }

            // históricas
            if (Array.isArray(this.ubicacionesHistoricas) && this.ubicacionesHistoricas.length > 0) {
                this.ubicacionesHistoricas.forEach((u, index) => {
                    const lat = Number(u.lat);
                    const lng = Number(u.lng);

                    if (
                        !isFinite(lat) || !isFinite(lng) ||
                        lat < -90 || lat > 90 ||
                        lng < -180 || lng > 180
                    ) return;

                    const marker = L.circleMarker([lat, lng], {
                        radius: 8,
                        color: '#ffffff',
                        weight: 2,
                        fillColor: '#1976d2',
                        fillOpacity: 1
                    })
                    .addTo(this.map)
                    .bindPopup(`
                        <b>Ubicación histórica ${index + 1}</b><br>
                        ${u.direccion || 'Sin dirección'}
                    `);

                    this.markersHistoricos.push(marker);
                    bounds.push([lat, lng]);
                });
            }

            setTimeout(() => {
                if (!this.map) return;

                this.map.invalidateSize();

                if (bounds.length === 1) {
                    this.map.setView(bounds[0], 15);
                    return;
                }

                if (bounds.length > 1) {
                    if (this.multiplesCiudades) {
                        const paisConfig2 = this.getCenterByPais(this.dato.oid_pais);
                        this.map.setView(paisConfig2.center, paisConfig2.zoom);
                    }

                    setTimeout(() => {
                        if (!this.map) return;

                        this.map.fitBounds(bounds, {
                            padding: [60, 60],
                            maxZoom: 12
                        });
                    }, 200);
                }
            }, 350);
        },
        async cargarCatalogosLaborales() {
            try {
                const [responseG, responseC, responseU, responseD] = await Promise.all([
                    axios.get('api/Grados/Listar'),
                    axios.get('api/Cargos/Listar'),
                    axios.get('api/Unidads/Listar'),
                    axios.get('api/Destinos/Listar')
                ]);

                this.Lgrado = responseG.data;
                this.Lcargo = responseC.data;
                this.Lunidad = responseU.data;
                this.Ldestino = responseD.data;
            } catch (error) {
                console.error(error);
            }
        },
        async cargarCatalogos() {
            await loadAll();

            this.Catalogo.TipoDocumento   = getOptionsByCodigo('TipoDocumento');
            this.Catalogo.Nacionalidad = getOptionsByCodigo('Nacionalidad');
            this.Catalogo.Genero        = getOptionsByCodigo('Genero');
            this.Catalogo.EstadoCivil        = getOptionsByCodigo('EstadoCivil');
        },
        getEstadoN,
        formatoFecha(fecha) {
            if (!fecha) return "-";
            const f = new Date(fecha);
            if (isNaN(f)) return fecha;
            return f.toLocaleDateString("es-BO", {
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        },
        async cargarPerfil() {
            try {
                let idUsuario = null;

                // Si viene desde otro componente, usar ese id
                if (this.personaId !== null && this.personaId !== undefined) {
                    idUsuario = Number(this.personaId);
                } else {
                    // Si no viene prop, usar el usuario en sesión
                    idUsuario = Number(this.personaOid);
                }

                if (!idUsuario || isNaN(idUsuario)) {
                    this.snackbarMensaje = "No se encontró el usuario en sesión";
                    this.snackbarColor = "error";
                    this.snackbar = true;
                    return;
                }

                const response = await axios.get(`api/PersonaInfoGenerals/Mostrar/${idUsuario}`);
                this.perfil = response.data || {};
            } catch (error) {
                console.error("Error al cargar el perfil:", error);
                this.snackbarMensaje = "Error al cargar la información del perfil";
                this.snackbarColor = "error";
                this.snackbar = true;
            }
        },
        async ejecutarAccion(item) {
            switch (item.accion) {
                case "datos":
                    await this.abrirPersonaDialogDatos();
                    return;
                case "domicilios":
                    await this.abrirDialogMapa();
                    return;
                case "carnet":
                    this.dialog_carnet = true;
                    return;
                case "track":
                    await this.abrirDialogTrack();
                    return;
                case "contactos":
                    await this.abrirDialogFamiliar();
                    return;

                case "estudios":
                case "configuracion":
                    default:
                        this.mostrarModuloDesarrollo(item.titulo);
                        return;
            }

            this.snackbarColor = "info";
            this.snackbar = true;
        },
        getPaisN, getDeptoN, getCiudadN, getNameById,
        async abrirPersonaDialogDatos() {
            try {
                let idUsuario = null;

                // Si viene desde otro componente, usar ese id
                if (this.personaId !== null && this.personaId !== undefined) {
                    idUsuario = Number(this.personaId);
                } else {
                    // Si no viene prop, usar el usuario en sesión
                    idUsuario = Number(this.personaOid);
                }

                if (!idUsuario || isNaN(idUsuario)) {
                    this.snackbarMensaje = "No se encontró el usuario en sesión";
                    this.snackbarColor = "error";
                    this.snackbar = true;
                    return;
                }

                const response = await axios.get(`api/PersonaInfoGenerals/Mostrar/${idUsuario}`);
                const data = response.data || {};

                this.dato = {
                    oid: data.oid || 0,

                    correo: data.correo || '',
                    nombres: data.nombres || '',
                    primero_apellido: data.primero_apellido || '',
                    segundo_apellido: data.segundo_apellido || '',
                    tercer_apellido: data.tercer_apellido || '',
                    apellidos: [
                        data.primero_apellido,
                        data.segundo_apellido,
                        data.tercer_apellido
                    ].filter(Boolean).join(' '),

                    oid_tipo_documento: data.oid_tipo_documento ?? null,
                    documento: data.documento || '',
                    expedido: data.expedido || '',

                    oid_genero: data.oid_genero ?? null,
                    fecha_nacimiento: data.fecha_nacimiento || null,
                    oid_estado_civil: data.oid_estado_civil ?? null,

                    oid_pais_nacimiento: data.oid_pais_nacimiento ?? null,
                    oid_depto_nacimiento: data.oid_depto_nacimiento ?? null,
                    oid_ciudad_nacimiento: data.oid_ciudad_nacimiento ?? null,

                    oid_nacionalidad_origen: data.oid_nacionalidad_origen ?? null,
                    oid_nacionalidad_actual: data.oid_nacionalidad_actual ?? null,

                    direccion: data.direccion || '',
                    calle: data.calle || '',
                    zona: data.zona || '',
                    nro_domicilio: data.nro_domicilio || '',
                    oid_pais: data.oid_pais ?? null,
                    oid_depto: data.oid_depto ?? null,
                    oid_ciudad: data.oid_ciudad ?? null,
                    telefono: data.telefono || '',

                    cod_salud: data.cod_salud || '',
                    registro_cua: data.registro_cua || '',
                    nro_cuenta: data.nro_cuenta || '',
                    grado_incapacidad: data.grado_incapacidad || '',
                    bono_egresado: data.bono_egresado || '',
                    cod_cargo: data.cod_cargo || '',
                    oid_tipo_sangre: data.oid_tipo_sangre ?? null,

                    n_contacto: data.n_contacto || '',
                    nro_contacto: data.nro_contacto || '',
                    oid_parentesco_contacto: data.oid_parentesco_contacto ?? null,

                    activo: data.activo,
                    verificado: data.verificado,
                    created_at: data.created_at || null
                };

                this.dialog_datos = true;
            } catch (error) {
                console.error("Error al abrir datos personales:", error);
                this.snackbarMensaje = "Error al cargar los datos personales";
                this.snackbarColor = "error";
                this.snackbar = true;
            }
        },
        async abrirDialogMapa() {
            try {
                let idUsuario = null;

                if (this.personaId !== null && this.personaId !== undefined) {
                    idUsuario = Number(this.personaId);
                } else {
                    idUsuario = Number(this.personaOid);
                }

                if (!idUsuario || isNaN(idUsuario)) {
                    this.snackbarMensaje = "No se encontró el usuario en sesión";
                    this.snackbarColor = "error";
                    this.snackbar = true;
                    return;
                }

                const response = await axios.get(`api/PersonaInfoGenerals/Mostrar/${idUsuario}`);
                const data = response.data || {};

                const responseU = await axios.get('api/PersonaUbicacions/Listar');
                const ubicaciones = Array.isArray(responseU.data) ? responseU.data : [];

                const historicoPersona = ubicaciones.filter(u =>
                    Number(u.oid_persona) === Number(idUsuario)
                );

                const historicoSinActual = historicoPersona.filter(u => {
                    const mismaLat = Number(u.lat) === Number(data.lat);
                    const mismaLng = Number(u.lng) === Number(data.lng);
                    return !(mismaLat && mismaLng);
                });

                this.dato = {
                    oid: data.oid || 0,
                    correo: data.correo || '',
                    nombres: data.nombres || '',
                    apellidos: [data.primero_apellido, data.segundo_apellido].filter(Boolean).join(' '),
                    direccion: data.direccion || '',
                    oid_pais: data.oid_pais ?? null,
                    oid_depto: data.oid_depto ?? null,
                    oid_ciudad: data.oid_ciudad ?? null,
                    lat: data.lat ?? null,
                    lng: data.lng ?? null,
                };

                this.ubicacionesHistoricas = historicoSinActual;

                const ciudades = new Set([
                    this.dato.oid_ciudad,
                    ...historicoSinActual.map(x => x.oid_ciudad)
                ].filter(x => x !== null && x !== undefined));

                this.multiplesCiudades = ciudades.size > 1;

                this.dialog_mapa = true;
            } catch (error) {
                console.error("Error al abrir mapa:", error);
                this.snackbarMensaje = "Error al cargar las ubicaciones";
                this.snackbarColor = "error";
                this.snackbar = true;
            }
        },
        async abrirDialogTrack() {
            try {
                let idUsuario = null;

                if (this.personaId !== null && this.personaId !== undefined) {
                    idUsuario = Number(this.personaId);
                } else {
                    idUsuario = Number(this.personaOid);
                }

                if (!idUsuario || isNaN(idUsuario)) {
                    this.snackbarMensaje = "No se encontró el usuario en sesión";
                    this.snackbarColor = "error";
                    this.snackbar = true;
                    return;
                }

                const [personaResponse, historialResponse, estadosResponse] = await Promise.all([
                    axios.get(`api/PersonaInfoGenerals/Mostrar/${idUsuario}`),
                    axios.get(`api/PersonaHistorials/MostrarPorPersona/${idUsuario}`),
                    axios.get(`api/PersonaHistorialEstados/MostrarPorPersona/${idUsuario}`)
                ]);

                const data = personaResponse.data || {};

                this.dato = {
                    ...this.dato,

                    oid: data.oid || 0,
                    correo: data.correo || '',
                    nombres: data.nombres || '',
                    apellidos: [data.primero_apellido, data.segundo_apellido].filter(Boolean).join(' '),

                    oid_estado: data.oid_estado ?? null,
                    cl1: data.cl1 || '',
                    cl2: data.cl2 || '',
                    fecha_ingreso: data.fecha_ingreso || null,
                    fecha_retiro: data.fecha_retiro || null,
                    fecha_reintegro: data.fecha_reintegro || null,
                    oid_grado: data.oid_grado ?? null,
                    oid_cargo: data.oid_cargo ?? null,
                    oid_unidad: data.oid_unidad ?? null,
                    oid_destino: data.oid_destino ?? null,
                };

                this.historialLaboral = historialResponse.data || [];
                this.historialEstados = estadosResponse.data || [];

                this.dialog_track = true;

            } catch (error) {
                console.error("Error al abrir track:", error);
                this.snackbarMensaje = "Error al cargar el track del funcionario";
                this.snackbarColor = "error";
                this.snackbar = true;
            }
        },
        async abrirDialogFamiliar() {
            const idUsuario = this.personaId !== null && this.personaId !== undefined
                ? Number(this.personaId)
                : Number(this.personaOid);

            if (!idUsuario || isNaN(idUsuario)) {
                this.snackbarMensaje = "No se encontró el usuario";
                this.snackbarColor = "error";
                this.snackbar = true;
                return;
            }

            this.dialog_familiar = true;
        },
        getCenterByPais(oidPais) {
            const centros = {
                2: { center: [4.5709, -74.2973], zoom: 5 }, // Colombia
                1: { center: [-16.2902, -63.5887], zoom: 5 }, // Bolivia, ejemplo
            };

            return centros[oidPais] || { center: [4.5709, -74.2973], zoom: 5 };
        },
        formatCoord(value) {
            const n = Number(value);
            if (!isFinite(n)) return '—';
            return n.toFixed(6);
        },
        formatoFechaHora(fecha) {
            if (!fecha) return '—';
            const f = new Date(fecha);
            if (isNaN(f)) return fecha;

            return f.toLocaleString('es-BO', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        getAccionHistorial(accion) {
            const acciones = {
                1: 'Corrección',
                2: 'Actualización'
            };

            return acciones[Number(accion)] || '—';
        },
        getGradoN(id) {
            const item = (this.Lgrado || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : '—';
        },
        getCargoN(id) {
            const item = (this.Lcargo || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : '—';
        },
        getUnidadN(id) {
            const item = (this.Lunidad || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : '—';
        },
        getDestinoN(id) {
            const item = (this.Ldestino || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : '—';
        },
        // Mostrar detalles
        async mostrar(id) {
            try {
                const response = await axios.get(`api/PersonaInfoGenerals/Mostrar/${id}`);
                this.dato = response.data;
                this.isNew = false;
                this.formTitle = 'Detalle Usuario';
                this.dialogdetail = true;
            } catch (error) {
                console.error(error);
            }
        },
        // Abrir el diálogo para crear una nuevo
        nueva() {
            this.dato = {
                oid: 0,
                names: '',
                surname: '',
                email: '',
                oid_rol: null,
                oid_area: null,
                activo: null
            };
            this.isNew = true;
            this.formTitle = 'Crear Usuario';
            this.dialog = true;
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.resetValidation();
                this.formValid= false;
            });
        },
        // Abrir el diálogo para actualizar
        editar(dato) {
            this.dato = { ...dato };
            this.isNew = false;
            this.formTitle = 'Actualizar Usuario';
            this.dialog = true;
        },
        // Guardar creada o actualizada
        async guardar() {
            // VALIDACION
            const ok = this.$refs.form && this.$refs.form.validate();
            if (!ok) return;

            this.dialog_guardando = true;
            try {        
                if (this.isNew) {
                    // Crear el área
                    const respuestaCrear = await axios.post('api/PersonaInfoGenerals/Crear', this.dato);
                } else {
                    // Actualizar el área
                    await axios.put(`api/PersonaInfoGenerals/Actualizar`, this.dato);
                }

                // Reset del formulario
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }

                // Limpiar el formulario después de guardar o actualizar
                this.dato = { 
                    oid: 0, 
                    names: '',
                    surname: '',
                    email: '',
                    oid_rol: null,
                    oid_area: null,
                    activo: null
                };
                // Después de guardar exitosamente el registro:
                this.dialog = false;
                await this.listar();
                
                this.snackbarMensaje = "Se guardo correctamente";
                this.snackbarColor = "success";
                this.snackbar = true;
            }catch(error) {
                console.error(error);
                this.snackbarMensaje = "Error al guardar";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_guardando = false;
            }
        },
        // Eliminar
        async eliminar(id) {
            try {
                await axios.delete(`api/PersonaInfoGenerals/Eliminar/${id}`);
                this.listar();
                this.cancelarEliminar();
            } catch (error) {
                console.error(error);
            }
        },
        // Confirmar eliminación
        confirmarEliminar(id) {
            this.confirmItemId = id;
            this.showConfirmDialog = true;
        },
        // Cancelar eliminación
        cancelarEliminar() {
            this.confirmItemId = null;
            this.showConfirmDialog = false;
        },
        mostrarModuloDesarrollo(titulo) {
            this.moduloDesarrollo = titulo || 'seleccionado';
            this.dialog_desarrollo = true;
        },
        calcularEdad(fechaNacimiento) {
            if (!fechaNacimiento) return null;

            const nacimiento = new Date(fechaNacimiento);

            if (isNaN(nacimiento)) return null;

            const hoy = new Date();

            let edad = hoy.getFullYear() - nacimiento.getFullYear();

            const mes = hoy.getMonth() - nacimiento.getMonth();

            if (
                mes < 0 ||
                (mes === 0 && hoy.getDate() < nacimiento.getDate())
            ) {
                edad--;
            }

            return `${edad} años`;
        },
    },
};
</script> 

<style scoped>
p {
    font-family: 'Heebo', sans-serif !important;
}

h1 {
    font-family: 'Heebo', sans-serif !important;
}

.perfil-root {
    background:
        radial-gradient(circle at top right, rgba(201, 165, 56, 0.12), transparent 26%),
        linear-gradient(180deg, #f7f8f3 0%, #eef0ea 100%);
    padding: 20px;
    padding-bottom: 48px;
    box-sizing: border-box;
    min-height: calc(100vh - 80px);
}

.perfil-shell {
    width: min(calc(100% - 24px), 1360px);
    max-width: 1360px;
    margin: 0 auto;
}

.perfil-header {
    background: #838858;
    border: 1px solid rgba(201, 165, 56, 0.55);
    border-radius: 20px;
    padding: 8px 20px;
    box-shadow: 0 14px 34px rgba(56, 61, 24, 0.16);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
}

.perfil-title {
    color: #ffffff;
    font-size: 24px;
    font-weight: 800;
    margin: 0;
    letter-spacing: 0.04em;
    line-height: 1.1;
}

.perfil-header-status {
    display: flex;
    align-items: stretch;
    justify-content: flex-end;
    gap: 12px;
    flex-wrap: wrap;
}

.status-pill {
    min-width: 120px;
    padding: 8px 14px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.18);
}

.status-pill--soft {
    background: rgba(255, 255, 255, 0.1);
}

.status-pill__label {
    display: block;
    color: #e4b510;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.status-pill__value {
    display: block;
    color: #ffffff;
    font-size: 18px;
    font-weight: 800;
    margin-top: 3px;
}

.perfil-card {
    background: #ffffff !important;
    border: 1px solid rgba(108, 117, 51, 0.14) !important;
    border-radius: 20px !important;
    box-shadow: 0 14px 36px rgba(59, 71, 33, 0.08);
}

.perfil-card--side {
    background: linear-gradient(180deg, #ffffff 0%, #f4f5f0 100%) !important;
}

.basic-strip {
    display: grid;
    grid-template-columns: minmax(320px, 520px) minmax(0, 1fr);
    gap: 20px;
    align-items: center;
    padding: 18px 20px !important;
}

.basic-strip__identity {
    display: flex;
    align-items: center;
    gap: 18px;
    padding-right: 10px;
    border-right: 1px solid rgba(108, 117, 51, 0.14);
}

.basic-strip__copy {
    min-width: 0;
}

.basic-strip__content {
    min-width: 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.perfil-avatar {
    border: 4px solid #f7c325;
    box-shadow: 0 0 0 8px rgba(231, 181, 16, 0.12);
}

.perfil-nombre {
    color: #384018;
    font-size: 24px;
    font-weight: 800;
    text-transform: uppercase;
    line-height: 1.2;
}

.perfil-subtitulo {
    color: #6b7280;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.08em;
}

.perfil-subtitulo--cargo {
    margin-top: 6px;
    margin-bottom: 1px;
}

.perfil-subtitulo--correo {
    margin-top: 0;
    letter-spacing: 0.03em;
    text-transform: none;
}

.section-title {
    color: #5e672c;
    font-size: 21px;
    font-weight: 800;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(108, 117, 51, 0.18);
    padding-bottom: 10px;
    letter-spacing: 0.02em;
}

.section-title--dialog {
    color: #384018;
    font-size: 18px;
}

.section-title--compact {
    font-size: 17px;
    padding-bottom: 8px;
}

.info-box {
    background: linear-gradient(180deg, #f8f9f6 0%, #eef0eb 100%);
    border: 1px solid rgba(108, 117, 51, 0.12);
    border-left: 4px solid #c9a538;
    border-radius: 14px;
    padding: 6px 10px;
    margin-bottom: 12px;
    min-height: 50px;
}

.info-box--compact {
    min-height: 50px;
    padding: 6px 10px;
    margin-bottom: 8px;
}

.info-label {
    color: #727b4a;
    font-size: 12px;
    font-weight: 800;
    margin-bottom: 1px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.info-value {
    color: #303641;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.35;
    word-break: break-word;
}

.compact-summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}

.compact-summary-grid--wide {
    width: min(100%, 920px);
    grid-template-columns: minmax(140px, 160px) minmax(140px, 160px) minmax(140px, 160px) minmax(140px, 160px);
    justify-content: end;
}

.compact-pill {
    background: rgba(255, 255, 255, 0.78);
    border: 1px solid rgba(108, 117, 51, 0.12);
    border-radius: 14px;
    padding: 11px 12px;
    min-height: 74px;
}

.compact-pill--full {
    grid-column: span 2;
}

.compact-pill__label {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #727b4a;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 6px;
}

.compact-pill__icon {
    flex: 0 0 auto;
}

.compact-pill__value {
    display: block;
    color: #303641;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.35;
    word-break: break-word;
}

.menu-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    column-gap: 50px;
    row-gap: 14px;
}

.menu-grid--four-up {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.menu-grid__item {
    min-width: 0;
}

.menu-card {
    background: linear-gradient(180deg, #f9faf8 0%, #f1f3ed 100%) !important;
    border: 1px solid rgba(108, 117, 51, 0.14);
    border-radius: 18px !important;
    min-height: 128px;
    padding: 18px 12px;
    text-align: center;
    cursor: pointer;
    transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.menu-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 14px 24px rgba(59, 71, 33, 0.12);
    border-color: rgba(201, 165, 56, 0.65);
}

.menu-icon-wrapper {
    margin-bottom: 6px;
}

.menu-title {
    color: #384018;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 2px;
    line-height: 1.2;
}

.menu-subtitle {
    color: #6b7280;
    font-size: 12px;
    line-height: 1.2;
}

.dialog-card {
    background: #fbfcfa !important;
}

.dialog-header {
    background: linear-gradient(180deg, #eef0ea 0%, #e2e6d8 100%);
    border-bottom: 1px solid rgba(108, 117, 51, 0.15);
}

.dialog-title {
    font-size: 22px;
}

.header-close {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(108, 117, 51, 0.14);
}

.dialog-action {
    background: #5e672c !important;
    color: #ffffff !important;
    border-radius: 12px !important;
    padding: 0 18px !important;
}

.legend-label {
    color: #4b5563;
    font-size: 14px;
    font-weight: 700;
}

.mapa-surface {
    height: 300px;
    border-radius: 16px;
    border: 1px solid rgba(108, 117, 51, 0.14);
    overflow: hidden;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
}

.v-dialog {
    border-radius: 18px !important;
}

.marker-red {
    filter: hue-rotate(0deg) saturate(2.5) brightness(1);
}

.marker-blue {
    filter: hue-rotate(180deg) saturate(2.5) brightness(1);
}

.legend-dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: inline-block;
    border: 2px solid #ffffff;
}

.legend-dot-red {
    background: #d32f2f;
}

.legend-dot-blue {
    background: #1976d2;
}

.historial-table {
    background: #ffffff !important;
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid rgba(108, 117, 51, 0.14);
}

.historial-table table {
    width: 100%;
    border-collapse: collapse;
}

.historial-table thead {
    background: rgba(201, 165, 56, 0.14);
}

.historial-table th {
    color: #5e672c !important;
    font-weight: 800;
    font-size: 13px;
    text-transform: uppercase;
    padding: 12px 10px !important;
    border-bottom: 1px solid rgba(108, 117, 51, 0.12);
}

.historial-table td {
    color: #303641 !important;
    padding: 11px 10px !important;
    border-bottom: 1px solid rgba(108, 117, 51, 0.08);
}

.historial-table tbody tr:hover {
    background: rgba(108, 117, 51, 0.04);
}

.historial-empty {
    color: #6b7280 !important;
    font-weight: 700;
}

@media (min-width: 1600px) {
    .perfil-shell {
        width: min(calc(100% - 32px), 1680px);
        max-width: 1680px;
    }
}

@media (max-width: 1264px) {
    .perfil-title {
        font-size: 22px;
    }

    .menu-card {
        min-height: 96px;
    }

    .compact-summary-grid--wide {
        grid-template-columns: minmax(130px, 0.85fr) minmax(130px, 0.85fr) minmax(200px, 1.3fr);
    }
}

@media (max-width: 960px) {
    .perfil-root {
        padding: 14px;
        padding-bottom: 36px;
    }

    .perfil-header {
        padding: 16px 18px;
    }

    .perfil-title {
        font-size: 22px;
    }

    .perfil-header-status {
        width: 100%;
        justify-content: flex-start;
    }

    .perfil-nombre {
        font-size: 21px;
    }

    .section-title {
        font-size: 18px;
    }

    .menu-title {
        font-size: 16px;
    }

    .menu-grid--four-up {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .compact-summary-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .basic-strip {
        grid-template-columns: 1fr;
        gap: 14px;
    }

    .basic-strip__identity {
        border-right: 0;
        padding-right: 0;
        padding-bottom: 12px;
        border-bottom: 1px solid rgba(108, 117, 51, 0.14);
    }

    .basic-strip__content {
        justify-content: stretch;
    }

    .compact-summary-grid--wide {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: 100%;
    }
}

@media (max-width: 600px) {
    .perfil-header {
        flex-direction: column;
        align-items: flex-start;
        padding: 12px 14px;
    }

    .status-pill {
        min-width: 0;
        width: calc(50% - 6px);
    }

    .menu-grid {
        grid-template-columns: 1fr;
    }

    .compact-summary-grid {
        grid-template-columns: 1fr;
    }

    .compact-summary-grid--wide {
        grid-template-columns: 1fr;
    }

    .compact-pill--full {
        grid-column: auto;
    }
}
</style>
